import { http } from '@/utils/http';
import qs from 'qs';
// const baseUrl = '/vote/2020project/2020hometownstory/controller.php?enews=';
const baseUrl = '/vote/2020project/2020green/controller.php?enews=';

export const getBaseInfo = () => {
  return http.get(`${baseUrl}base-info`);
};
// 列表
export const voteList = (page: number , awards: number , search?: any) => {
  return http.get(`${baseUrl}vote-list&page=` + page + '&search=' + search + '&awards=' + awards );
};

// 规则
export const getRules = () => {
  return http.get(`${baseUrl}rules`);
};

// 获取详情页面
export const detail = (id: any) => {
  return http.get(`${baseUrl}detail&id=` + id);
};

// 活动投票
export function vote(
  voteName: string,
  data: {
    id: number | string;
    source: number | string;
    udid?: any;
    appkey?: any;
    code?: any;
    csessionid?: string;
    scene?: string;
    sig?: string;
    token?: string;
  },
) {
  const qsData = qs.stringify(data);
  return http.post(`${baseUrl}vote`, qsData);
}
